function createFavoritesTrainingCardList(dataArray, parentContainer){
    const arr = dataArray;

    arr.map(card => parentContainer.append(createFavoritesTrainingCardMarkup(card)));
}

function createFavoritesTrainingCardMarkup(card){
    let formattedDate = moment(card.date).format('ll');
    const baseElement = card.link != '' && card.link != false && card.link != undefined
    ? 'a' : 'div';
    const link = baseElement == 'a' ? `href='${card.link}'` : '';
    let infoArray = [{"Mountain": card.mountain}, {"Trail": card.trail}, {"Team": card.team}];
 
    const cardMarkup = 
    `<${baseElement} class="favorite-training-card js-card active" ${link} data-id='${card.id}'>
        <div class='favorite-training-card__top'>
            <div class='fz-12-16 fw-600 c-orange'>${formattedDate}</div>
            <div class='fz-15-26 fw-600 c-dark toe pr-32'>${card.event}</div>
            ${card.favorite ? '<span class="favorite-training-card__favorite js-card-icon-favorite"></span>' : ''}
        </div>
        <div class='h-1 bg-c-gray-2'></div>
        <div class='favorite-training-card__info fz-12-16 fw-600'>
            ${
                infoArray.map(function(item){
                    const layout = 
                    `<div class='c-gray-7'>${Object.keys(item)}</div>
                    <div class='c-dark'>${item[Object.keys(item)]}</div>`
                    return layout;
                }).join('')
            }
        </div>
    </${baseElement}>`

    return cardMarkup;
}

$(document).ready(function(){
    if ($('.js-favorites-container-trainings').length && favoritesTrainingData.length > 0){
        createFavoritesTrainingCardList(favoritesTrainingData, $('.js-favorites-container-trainings'));
    }
});
